import React from 'react';
import { Icon, Tooltip } from '@material-ui/core';
import { ToggleButton, ToggleButtonProps } from '@material-ui/lab';
import { PlayerAction } from '@screens/players/button.bar/types/player.action.type';

interface PlayerPropertyToggleProps extends ToggleButtonProps {
  data: PlayerAction;
}

export function PlayerPropertyToggle({ data, ...rest }: PlayerPropertyToggleProps) {
  return (
    <Tooltip title={data.text} aria-label={data.text}>
      <ToggleButton value={data.id} aria-label={data.text} {...rest}>
        <Icon>{data.icon}</Icon>
      </ToggleButton>
    </Tooltip>
  );
}
